import React, { useState } from 'react'

import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

import TransactionsResumeYear from './TransactionsResumeYear'
import TransactionsResumeMonth from './TransactionsResumeMonth'
import TransactionsResumeDay from './TransactionsResumeDay'
import TransactionsResumeOverall from './TransactionsResumeOverall'

export default function TransactionsMain() {
  const [tabIndex, setTabIndex] = useState(0)

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={(e, value) => setTabIndex(value)}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Resumo geral" />
        <Tab label="Resumo ano atual" />
        <Tab label="Resumo por mês" />
        <Tab label="Resumo por dia" />
      </Tabs>
      {tabIndex === 0 && <TransactionsResumeOverall />}
      {tabIndex === 1 && <TransactionsResumeYear />}
      {tabIndex === 2 && <TransactionsResumeMonth />}
      {tabIndex === 3 && <TransactionsResumeDay />}
    </>
  )
}
